import { isMessageViewed, registerMessageViewed } from "../../utils/session-storage-manager";
import { overlayTemplate } from "./templates/overlay-template";
import { tooltipTemplate } from "./templates/tooltip-template";
import { addCustomEventListener, removeCustomEventListener } from "../../utils/event-listener";
import * as liteComponents from "../../komodo-assets/lite-components";
import { isBottomSpaceSmaller } from "../../utils/window-utils";
import { getBoundingRect, insertNodeAfterReference } from "../../utils/html-elements-utils";
var KOMODO_TOOLTIP_OPENED_EVENT = "opened.komodo.tooltip";
var KOMODO_TOOLTIP_CLOSED_EVENT = "closed.komodo.tooltip";
/**
 * Create a tooltip element with the given options
 * @param {*} options
 * @param {*} generateKomodoTooltipInstance
 * @returns
 */ export var createTooltip = function(options, generateKomodoTooltipInstance) {
    if (isMessageViewed(options.componentId) && !options.overEnabled) {
        return;
    }
    var targetElement = document.getElementById(options.targetId);
    if (!targetElement) {
        return console.error("Target element with id ".concat(options.targetId, " not found"));
    }
    var tooltip = tooltipTemplate(options, function closeIconFunction() {
        dispatchCloseTooltipEvent(tooltip);
    });
    var tooltipOverlay = options.withOverlay ? overlayTemplate(function() {
        return dispatchCloseTooltipEvent(tooltip);
    }) : null;
    var komodoTooltipInstance = generateKomodoTooltipInstance(tooltip);
    handleKomodoCustomEvents(komodoTooltipInstance, options, tooltipOverlay, targetElement);
    handleMouseEvents(komodoTooltipInstance, targetElement, options);
    handleWindowEvents(komodoTooltipInstance, targetElement);
    insertNodeAfterReference(tooltip, targetElement);
    if (!isMessageViewed(options.componentId)) {
        dispatchOpenTooltipEvent(tooltip);
        if (tooltipOverlay == null) return;
        document.body.appendChild(tooltipOverlay);
    }
    if (options.scrollToEnabled || options.scrollToEnabled === undefined || options.scrollToEnabled === null) {
        setTimeout(function() {
            // set interval for 3 retries with 500ms delay
            var retries = 3;
            var interval = setInterval(function() {
                if (retries === 0) {
                    clearInterval(interval);
                    return;
                }
                scrollToElementCenter(document.getElementById(options.targetId));
                retries--;
            }, 300);
        }, 500);
    }
};
function scrollToElementCenter(targetElement) {
    var _targetElement_getBoundingClientRect = targetElement.getBoundingClientRect(), top = _targetElement_getBoundingClientRect.top, height = _targetElement_getBoundingClientRect.height;
    var scrollToPosition = top + window.scrollY - window.innerHeight / 2 + height / 2;
    window.scrollTo({
        top: scrollToPosition
    });
}
/**
 * Position the tooltip and the arrow based on the target element position and the window size
 * @param tooltip
 * @param target
 */ var positionTooltipAndArrow = function(tooltip, target) {
    var childArrow = tooltip.firstElementChild;
    var targetCentralPoint = getBoundingRect(target).left + getBoundingRect(target).width / 2;
    if (targetCentralPoint < getBoundingRect(tooltip).width / 2) {
        tooltip.style.left = "0";
    } else if (targetCentralPoint + getBoundingRect(tooltip).width / 2 > window.innerWidth) {
        tooltip.style.right = "0";
    } else {
        var leftMinus = targetCentralPoint - 50 - getBoundingRect(tooltip).width / 2 < 0 ? 0 : 50;
        tooltip.style.left = "".concat(targetCentralPoint - leftMinus - getBoundingRect(tooltip).width / 2, "px");
    }
    if (isBottomSpaceSmaller(target, getBoundingRect(tooltip).height + 10)) {
        tooltip.classList.remove("kmd-tooltip--bottom");
        tooltip.classList.add("kmd-tooltip--top");
        tooltip.style.top = "".concat(getBoundingRect(target).top - getBoundingRect(tooltip).height - 10, "px");
    } else {
        tooltip.classList.remove("kmd-tooltip--top");
        tooltip.classList.add("kmd-tooltip--bottom");
        tooltip.style.top = "".concat(getBoundingRect(target).top + 40, "px");
    }
    if (childArrow) {
        childArrow.style.left = "".concat(targetCentralPoint - getBoundingRect(tooltip).left, "px");
    }
};
/**
 * Dispatch the close tooltip event for the given tooltip
 * @param tooltip : HTMLElement
 */ var dispatchCloseTooltipEvent = function(tooltip) {
    tooltip.classList.remove("is-visible");
    var customEvent = liteComponents.componentHandler.createEvent(KOMODO_TOOLTIP_CLOSED_EVENT, null, !1, !0);
    tooltip.dispatchEvent(customEvent);
};
/**
 * Dispatch the open tooltip event for the given tooltip
 * @param tooltip : HTMLElement
 */ var dispatchOpenTooltipEvent = function(tooltip) {
    tooltip.classList.add("is-visible");
    var customEvent = liteComponents.componentHandler.createEvent(KOMODO_TOOLTIP_OPENED_EVENT, null, !1, !0);
    tooltip.dispatchEvent(customEvent);
};
/**
 * Handle the custom events for the tooltip component
 * @param komodoTooltipInstance : KomodoTooltip
 * @param options : TooltipOptions
 * @param tooltipOverlay : HTMLElement | null
 * @param targetElement : HTMLElement
 */ var handleKomodoCustomEvents = function(komodoTooltipInstance, options, tooltipOverlay, targetElement) {
    addCustomEventListener(komodoTooltipInstance.element_, KOMODO_TOOLTIP_CLOSED_EVENT, function() {
        return console.log("Tooltip closed and registered as viewed");
    }, function() {
        return registerMessageViewed(options.componentId);
    }, function() {
        return tooltipOverlay === null || tooltipOverlay === void 0 ? void 0 : tooltipOverlay.remove();
    }, function() {
        if (!options.overEnabled) {
            // call the removeCustomEventListener function to remove all the event listeners
            clearCustomEventListeners(komodoTooltipInstance, targetElement);
            komodoTooltipInstance.element_.remove();
        }
    });
    addCustomEventListener(komodoTooltipInstance.element_, KOMODO_TOOLTIP_OPENED_EVENT, function() {
        return console.log("Tooltip opened");
    }, function() {
        return positionTooltipAndArrow(komodoTooltipInstance.element_, targetElement);
    });
};
/**
 * Handle the window events for the tooltip component
 * @param komodoTooltipInstance : KomodoTooltip
 * @param targetElement : HTMLElement
 */ var handleWindowEvents = function(komodoTooltipInstance, targetElement) {
    var tooltip = komodoTooltipInstance.element_;
    var positionTooltipAndArrowFunction = function() {
        return positionTooltipAndArrow(tooltip, targetElement);
    };
    addCustomEventListener(window, "scroll", positionTooltipAndArrowFunction);
    addCustomEventListener(window, "resize", positionTooltipAndArrowFunction);
};
/**
 * Handle the mouse over and leave events for the tooltip and the target element
 * @param komodoTooltipInstance : KomodoTooltip
 * @param targetElement : HTMLElement
 * @param options : TooltipOptions
 */ function handleMouseEvents(komodoTooltipInstance, targetElement, options) {
    var tooltipOvered = false;
    var targetElementOvered = false;
    var handleMouseLeave = function(element, setOveredFlag, checkOtherFlag, closeAction) {
        addCustomEventListener(element, "mouseleave", function() {
            if (!isMessageViewed(options.componentId)) return;
            setOveredFlag(false);
            setTimeout(function() {
                if (komodoTooltipInstance.element_.classList.contains("is-visible") && !checkOtherFlag()) closeAction();
            }, 150);
        });
    };
    var handleMouseOver = function(element, setOveredFlag) {
        addCustomEventListener(element, "mouseover", function() {
            if (!isMessageViewed(options.componentId)) return;
            setOveredFlag(true);
        });
    };
    handleMouseLeave(komodoTooltipInstance.element_, function(value) {
        return tooltipOvered = value;
    }, function() {
        return targetElementOvered;
    }, function() {
        return dispatchCloseTooltipEvent(komodoTooltipInstance.element_);
    });
    handleMouseOver(komodoTooltipInstance.element_, function(value) {
        return tooltipOvered = value;
    });
    handleMouseLeave(targetElement, function(value) {
        return targetElementOvered = value;
    }, function() {
        return tooltipOvered;
    }, function() {
        return komodoTooltipInstance.element_.classList.remove("is-visible");
    });
    handleMouseOver(targetElement, function(value) {
        return targetElementOvered = value;
    });
}
/**
 * Clear all the custom event listeners for the tooltip component
 * @param komodoTooltipInstance : KomodoTooltip
 * @param targetElement : HTMLElement
 */ function clearCustomEventListeners(komodoTooltipInstance, targetElement) {
    removeCustomEventListener(komodoTooltipInstance.element_, KOMODO_TOOLTIP_OPENED_EVENT);
    removeCustomEventListener(komodoTooltipInstance.element_, KOMODO_TOOLTIP_CLOSED_EVENT);
    removeCustomEventListener(targetElement, "mouseleave");
    removeCustomEventListener(targetElement, "mouseover");
    removeCustomEventListener(komodoTooltipInstance.element_, "mouseleave");
    removeCustomEventListener(komodoTooltipInstance.element_, "mouseover");
    removeCustomEventListener(window, "scroll");
    removeCustomEventListener(window, "resize");
}
